import type {Location} from '@/store/state/locations/state'
import type {GuidType} from '@/values/generic-type-definitions'
import {createContext, useContext} from 'react'

export const GlobalVesselFilterContext = createContext<GlobalVesselContextValue | undefined>(
    undefined,
)

export interface GlobalVesselContextValue {
    isLoading: boolean
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
    error: Error | null
    allVesselArray: Location[]
    selectedVesselArray: Location[]
    selectedVesselIds: Set<GuidType> | null
    onChange: (ids: Set<GuidType>) => void
}

export function useGlobalVesselFilterContext(): GlobalVesselContextValue {
    const context = useContext(GlobalVesselFilterContext)
    if (!context) {
        throw new Error(
            'useGlobalVesselFilterContext must be used within a GlobalVesselFilterProvider',
        )
    }
    return context
}
